// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.transfer-question-popup select {
    display: inline-block;
}

.transfer-question-popup .transfer-question-popup__header-info {
    color: #cccccc;
}

.transfer-question-popup .transfer-question-popup__header-bold {
    font-weight: 700;
}

.transfer-question-popup__button {
    margin-left: 0.2rem !important;
    margin-right: 0.2rem !important;
}

.transfer-question-popup .transfer-question-popup__button-apply {
    background-color: #d6ac17;
}

.transfer-question-popup .transfer-question-popup__button-cancel {
    background-color: #d22e37;
}

.transfer-question-popup .transfer-question-popup__option-active {
    background-color: #b9f6ca;
}

.transfer-question-popup .transfer-question-popup__option-inactive {
    background-color: #ffcdd2;
}

.select-target-first-option {
    color: #cccccc;
}

#select-target-label-label {
    font-size: initial;
}

#select-target-label {
    height: 40px;
}

.MuiSvgIcon-root {
    width: 1.5em !important;
    height: 1.5em !important;
}

.MuiInputBase-root {
    font-size: large !important;
}

.select-target-option {
    font-size: large;
}
`, "",{"version":3,"sources":["webpack://./src/app/nlp/topic-editor/transfer-question-popup/TransferQuestionPopup.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;IAC9B,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,wBAAwB;AAC5B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".transfer-question-popup select {\r\n    display: inline-block;\r\n}\r\n\r\n.transfer-question-popup .transfer-question-popup__header-info {\r\n    color: #cccccc;\r\n}\r\n\r\n.transfer-question-popup .transfer-question-popup__header-bold {\r\n    font-weight: 700;\r\n}\r\n\r\n.transfer-question-popup__button {\r\n    margin-left: 0.2rem !important;\r\n    margin-right: 0.2rem !important;\r\n}\r\n\r\n.transfer-question-popup .transfer-question-popup__button-apply {\r\n    background-color: #d6ac17;\r\n}\r\n\r\n.transfer-question-popup .transfer-question-popup__button-cancel {\r\n    background-color: #d22e37;\r\n}\r\n\r\n.transfer-question-popup .transfer-question-popup__option-active {\r\n    background-color: #b9f6ca;\r\n}\r\n\r\n.transfer-question-popup .transfer-question-popup__option-inactive {\r\n    background-color: #ffcdd2;\r\n}\r\n\r\n.select-target-first-option {\r\n    color: #cccccc;\r\n}\r\n\r\n#select-target-label-label {\r\n    font-size: initial;\r\n}\r\n\r\n#select-target-label {\r\n    height: 40px;\r\n}\r\n\r\n.MuiSvgIcon-root {\r\n    width: 1.5em !important;\r\n    height: 1.5em !important;\r\n}\r\n\r\n.MuiInputBase-root {\r\n    font-size: large !important;\r\n}\r\n\r\n.select-target-option {\r\n    font-size: large;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
